import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const VendorName: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Vendor Name',
  minWidth: 150,
  maxWidth: 264,
  accessorFn: (product) => product.vendor_name,
  sortKeyFn: (product) => product.vendor_name,
});
